import { Chart } from 'chart.js';

Chart.defaults.font.size = 11;
Chart.defaults.font.family = '"Inter", sans-serif';
